import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getProcedimientosPss: ["payload"],
  getProcedimientosPssLoading: null,
  getProcedimientosPssSuccess: ["getProcedimientosPssData"],
  getProcedimientosPssFailure: ["getProcedimientosPssError"],

  getMedicos: ["payload"],
  getMedicosLoading: null,
  getMedicosSuccess: ["getMedicosData"],
  getMedicosFailure: ["getMedicosError"],
});

export { Types };

export default Creators;